<template>
    <Link :href="route('brands.show', brand)">
        <div
            class="bg-white rounded-lg flex items-center justify-center py-2 px-4 h-16"
            :class="{'shadow-lg': !noShadow}"
            :style="{backgroundColor: !noBackground ? brand.background_colour : null}"
            v-bind="$attrs"
        >
            <img :src="brand.image" class="w-auto max-h-full lazy" :width="width">
        </div>
    </Link>
</template>

<script>
import {Link} from "@inertiajs/inertia-vue3";
import LazyLoad from "vanilla-lazyload";

export default {
    components: {Link},
    props: {
        brand: Object,
        width: [Number, String],
        noShadow: Boolean,
        noBackground: Boolean
    },
    mounted() {
        const lazyLoadInstance = new LazyLoad({});
    }
};
</script>

<style scoped>

</style>
